import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { QueryBuilder } from '@/core/uql';
import cloneDeep from 'lodash/cloneDeep';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { stat } from 'fs';

interface ShiftDetailsState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    document: any;

    inWorkStatus: any;
    formationStatus: any;
    workers: any[];
    notifications: any[];
    remains: any;
    meta: any;
    meta_worker: any;
}

const state: ShiftDetailsState = {
    loading: false,
    loaded: false,
    fatalError: false,

    document: null,

    inWorkStatus: null,
    formationStatus: null,
    workers: [],
    notifications: [],
    remains: null,
    meta: {},
    meta_worker: {},
};

const initState: any = cloneDeep(state);

export const SHIFT_DATA = 'GET_SHIFT_DATA';
export const SHIFT_WORKERS_DATA = 'GET_SHIFT_WORKERS_DATA';
export const LOAD_SHIFT_PRODUCTS = 'LOAD_SHIFT_PRODUCTS';
export const GET_WORK_STATUS = 'GET_WORK_STATUS';
export const GET_FORMATION_STATUS = 'GET_FORMATION_STATUS';
export const GET_SHIFT_NOTIFICATION = 'SHIFT_NOTIFICATION';
export const SHIFT_SETTING_VALUE_DATA = 'GET_SHIFT_SETTING_VALUE_DATA';

export function shiftWorkers(docId: string) {
  return {
    columns: {
      id: 'sw.id',
      employee_name: 'employee.name',
      role_name: 'role.name',
      is_manager: 'role.is_manager',
      is_combined: 'sw.is_combined',
      combine_time: 'sw.combine_time',
      is_timer_start: 'sw.is_timer_start',
    },

    from: 's:shift_workers',
    from_as: 'sw',
    page_size: 1000,
    joins: [
      {
        join: 's:employees',
        type: 'left',
        as:   'employee',
        on: {
          $eq: ['sw.employee_id', 'employee.id']
        }
      },
      {
        join: 's:voc_roles',
        type: 'left',
        as:   'role',
        on: {
          $eq: ['sw.role_id', 'role.id']
        }
      },
    ],
    order: [
      {$asc: ['sw.id']}
    ],
    where: {
      $eq: [`sw.shift_id`, {$: docId}]
    }
  }
}

export function shiftDetails(docId: string) {
  const columns: any = {
    id: 'shift.id',
    shift_date: 'shift.shift_date',
    begin_time: 'shift.begin_time',
    end_time: 'shift.end_time',
    real_begin_time: 'shift.real_begin_time',
    real_end_time: 'shift.real_end_time',
    created_at: 'shift.created_at',
    updated_at: 'shift.updated_at',
    line_template: 'shift.templates',
    created_by_name: 'employee.name',
    manager_name: 'employee.name',
    times_of_day: 'shift.times_of_day',
    close_state: 'shift.close_state',
    reason1: {
      $concat: ['acr1.name', {$: ' / '}, 'acst1.name']
    },
    reason2: {
      $concat: ['acr2.name', {$: ' / '}, 'acst2.name']
    },
    close_reason: 'shift.close_reasone',
    close_description: 'shift.close_description',
  };

  return {
      columns,
      from: 's:shifts',
      from_as: 'shift',
      joins: [
        {
          join: 's:voc_lines',
          type: 'left',
          as:   'line',
          on: {
            $eq: ['line.id', 'shift.line_id']
          }
        },
        {
          join: 's:employees',
          type: 'left',
          as:   'employee',
          on: {
            $eq: ['employee.id', 'shift.manager_id']
          }
        },
        {
          join: 's:ahead_close_reasons',
          type: 'left',
          as:   'acr1',
          on: {
            $eq: ['acr1.id', 'shift.close_reasone_line_1_id']
          }
        },
        {
          join: 's:ahead_close_sub_types',
          type: 'left',
          as:   'acst1',
          on: {
            $eq: ['acst1.id', 'acr1.ahead_close_sub_type_id']
          }
        },
        {
          join: 's:ahead_close_types',
          type: 'left',
          as:   'act1',
          on: {
            $eq: ['act1.id', 'acst1.ahead_close_type_id']
          }
        },

        {
          join: 's:ahead_close_reasons',
          type: 'left',
          as:   'acr2',
          on: {
            $eq: ['acr2.id', 'shift.close_reasone_line_2_id']
          }
        },
        {
          join: 's:ahead_close_sub_types',
          type: 'left',
          as:   'acst2',
          on: {
            $eq: ['acst2.id', 'acr2.ahead_close_sub_type_id']
          }
        },
        {
          join: 's:ahead_close_types',
          type: 'left',
          as:   'act2',
          on: {
            $eq: ['act2.id', 'acst2.ahead_close_type_id']
          }
        },
      ],
      where: {
        $eq: [`shift.id`, {$: docId}]
      }
  }
}

export const actions: ActionTree<ShiftDetailsState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, params) {
        const vm = (this as any)._vm;

        console.log('params', params);

        if (params.id == 'new') {
            state.document = {};
            state.loaded = true
        } else {
            return new Promise((resolve, reject) => {
                if (!params.silence) {
                    commit('START_LOADING');
                }

                vm.$db([
                    vm.$q(SHIFT_DATA)
                      .raw('documents.list')
                      .action(shiftDetails(params.id)),
                    vm.$q(SHIFT_WORKERS_DATA)
                      .raw('documents.list')
                      .action(shiftWorkers(params.id)),
                    vm.$q(GET_SHIFT_NOTIFICATION)
                      .raw('documents.list')
                      .action({
                        columns: {
                          body: 'vnbs.body',
                          done_time: 'vnbs.done_time'
                        },
                        from: 's:view_notification_by_shift',
                        from_as: 'vnbs',
                        where: {
                          $eq: [`vnbs.shift_id`, {$: params.id}]
                        }
                      }),
                ]).then(((result: ServerResult) => {
                    commit('SET_SHIFT_DATA', {
                      data: result.getOperation(SHIFT_DATA).getContent(),
                      workers: result.getOperation(SHIFT_WORKERS_DATA).getContent(),
                      notifications: result.getOperation(GET_SHIFT_NOTIFICATION).getContent()
                    });
                    if (!params.silence) {
                        commit('LOADED_SUCCESS');
                    }
                    resolve();
                }));
            })
        }
    },

    setTimer({ state, dispatch }, worker) {
      const vm = (this as any)._vm;

      vm.$db([
          (vm.$q('SHIFT_TO_WORK') as QueryBuilder)
            .update(worker.id, { is_timer_start: worker.is_timer_start })
      ])
      .then(() => {
          dispatch('loadData', { id: state.document.id, silence: true})
      })
    },

    startShift({ state, dispatch }) {
      const vm = (this as any)._vm;

      vm.$db([
          (vm.$q('SHIFT_TO_WORK') as QueryBuilder)
            .update(state.document.id, { real_begin_time: moment().format() })
      ])
      .then(() => {
          dispatch('loadData', { id: state.document.id, silence: true})
      })
    },

    stopShift({ state, dispatch }, {form, warehouse_id}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          const queries = [
              vm.$q(`SHIFT_CAN_CLOSE_VDP`)
                  .raw('documents.list')
                  .action({
                    columns: {
                      mark_no_incident: 'vbm.no_incident',
                      mark_water_state: 'vbm.water_state',
                      mark_no_fat: 'vbm.no_fat',
                      mark_normal_acidity: 'vbm.normal_acidity',
                      mark_temp: 'vbm.temp',
                      mark_acidity: 'vbm.acidity',
                      extract_time: 'sfv.extract_time',
                      recomended_ferment_time: 'sjv.recomended_ferment_time',
                      times_of_day: 's.times_of_day',
                      shift_date: 's.shift_date',
                      end_time: 's.end_time',
                      clot_datetime: 'vbm.datetime',
                      spv: 'spv.deleted_at',
                    },
                    from: 's:shift_plan_vdp',
                    from_as: 'spv',
                    joins: [
                      {
                        join: 's:shift_fact_vdp',
                        type: 'left',
                        as:   'sfv',
                        on: {
                          $eq: ['sfv.shift_plan_id', 'spv.id']
                        }
                      },
                      {
                        join: 's:shift_journal_vdp',
                        type: 'left',
                        as:   'sjv',
                        on: {
                          $eq: ['sjv.fact_id', 'sfv.id']
                        }
                      },
                      {
                        join: 's:view_base_mark',
                        type: 'left',
                        as:   'vbm',
                        on: {
                          $eq: ['vbm.id', 'sfv.id']
                        }
                      },
                      {
                        join: 's:shifts',
                        type: 'left',
                        as:   's',
                        on: {
                          $eq: ['s.id', 'spv.shift_id']
                        }
                      },
                    ],
                    where: {
                      $and: [
                        {$eq: [`spv.shift_id`, {$: state.document.id}]},
                        {$null: [`spv.deleted_at`]},
                      ]
                    },
                    orders: [
                      'item.extract_time',
                      'vbm.datetime',
                    ]
                  }),
                vm.$q(`SHIFT_CAN_CLOSE_ATOM`)
                  .raw('documents.list')
                  .action({
                    columns: {
                      id: 'sacp.id',
                      acidity_1: 'sja.acidity_1',
                      acidity_2: 'sja.acidity_2',
                      acidity_3: 'sja.acidity_3',
                      acidity_4: 'sja.acidity_4',
                      quality_id: 'sja.quality_id',
                      density_id: 'sja.density_id',
                      consitency_id: 'sja.consitency_id',
                      set_fan_date: 'sja.set_fan_date',
                      quantity: 'sfa.quantity',
                    },
                    from: 's:shift_atom_coock_plan',
                    from_as: 'sacp',
                    joins: [
                      {
                        join: 's:shift_journal_atom',
                        type: 'left',
                        as:   'sja',
                        on: {
                          $eq: ['sja.plan_id', 'sacp.id']
                        }
                      },
                      {
                        join: 's:shift_atom',
                        type: 'left',
                        as:   'sa',
                        on: {
                          $eq: ['sa.coock_plan_id', 'sacp.id']
                        }
                      },
                      {
                        join: 's:shift_fact_atom',
                        type: 'left',
                        as:   'sfa',
                        on: {
                          $eq: ['sfa.plan_id', 'sa.id']
                        }
                      },
                      {
                        join: 's:shifts',
                        type: 'left',
                        as:   's',
                        on: {
                          $eq: ['s.id', 'sacp.shift_id']
                        }
                      },
                    ],
                    where: {
                      $and: [
                        {$eq: [`sacp.shift_id`, {$: state.document.id}]},
                        {$null: [`sacp.deleted_at`]},
                      ]
                    },
                    orders: [
                      'item.extract_time',
                      'vbm.datetime',
                    ]
                  }),
                vm.$q(SHIFT_SETTING_VALUE_DATA)
                  .raw('documents.list')
                  .action({
                      columns: {
                          name: 's.name',
                          value: 's.value',
                      },
                      from: 's:settings',
                      from_as: 's',
                      where: {
                          $like: ['s.name', {$: 'shift_allow_close_%'}]
                      },
                      limit: 1
                  })
            ]
          vm.$db(queries)
            .then((result: ServerResult) => {
                const data: any = {
                    no_extrat_time: false,
                    no_clot: false,
                    no_extract: false,
                    no_clot_date: false,
                    no_ph_added: false,
                    no_required_fields: false,
                    no_quantity: false,
                }

                const settings = result.getOperation(SHIFT_SETTING_VALUE_DATA).getContent().documents.reduce((acc: any, row: any) => {
                  acc[row.name] = row.value == 'true'
                  return acc
                }, {})

                console.log(settings)

                result.getOperation('SHIFT_CAN_CLOSE_VDP').getContent().documents.map((item: any) => {
                  if (!item.deleted_at) {
                    const end_date = moment(item.shift_date + ' ' + item.end_time)
                    if (item.times_of_day == 'night') {
                      end_date.add({days: 1});
                    }
                    const extract_after = moment(end_date).isAfter(moment(form.real_end_time))
                    if (extract_after && !item.extract_time){
                      data.no_extract = true;
                    }
                    if (item.extract_time && item.clot_datetime !== item.extract_time && !extract_after) {
                      data.no_clot_date = true
                    } else {
                      data.no_clot_date = false
                    }
                    if (!item.extract_time && !extract_after) {
                        data.no_extrat_time = true
                    } 
                    if ((!item.mark_temp || !item.mark_acidity) && !extract_after) {
                        data.no_clot = true
                    }
                  }
                })
                result.getOperation('SHIFT_CAN_CLOSE_ATOM').getContent().documents.map((item: any) => {
                  if (!item.acidity_1) { 
                    data.no_ph_added = true
                  }
                  if (!item.quality_id || !item.density_id || !item.consitency_id) { 
                    data.no_required_fields = true
                  }
                  if (item.set_fan_date && !item.quantity) { 
                    data.no_quantity = true
                  }
                })
                if (data.no_extrat_time && data.no_extract && !settings.shift_allow_close_without_extract_time) {
                  reject("Вы не можете закрыть смену, пока не внесете данные по времени выемки оцененной партии в разделе «журнал»")
                } else if (data.no_clot && !settings.shift_allow_close_without_clots) {
                  if (data.no_extract) 
                    reject("Вы не можете закрыть смену, пока не внесете данные по оценке качества партии в разделе «сгустки»")
                  else {
                    reject("Вы не можете закрыть смену, пока не внесете данные по оценке партии (раздел «сгустки») той партии, время выемки которой внесли в раздел «журнал»")
                  }
                } else if (data.no_clot_date && !settings.shift_allow_close_without_clot_date) {
                  reject("Вы не можете закрыть смену, потому что время выемки партии в разделе «журнал» и время крайней оценки партии в разделе «сгустки» не совпадают")
                } else if (data.no_extract && !settings.shift_allow_close_without_extract_time) {
                  reject("Вы не можете закрыть смену, пока не внесете данные по времени выемки партии в разделе «журнал» и не внесете данные по оценке качества партии в разделе «сгустки»")
                } else if (data.no_ph_added && !settings.shift_allow_close_without_ph) {
                  reject("Вы не можете закрыть смену, пока не внесете данные по pH в разделел «журнал»")
                } else if (data.no_required_fields && !settings.shift_allow_close_without_required_fields) {
                  reject("Вы не можете закрыть смену, пока не заполните поля «Качество ПП при загрузке», «Густота продукта во время варки» и «Консистенция продукта на розливе» в разделел «журнал»")
                } else if (data.no_quantity && !settings.shift_allow_close_without_quantity) {
                  reject("Вы не можете закрыть смену, пока не укажете количество выпущенной продукции в разедел «факт розлива»")
                } else  {
                    const queries = [
                      vm.$q(`SHIFT_CLOSE_WORKERS`)
                        .update(state.document.id, {})
                        .updateManyRelation('shift_workers', 'shift_id', (updateRelated: any) => {
                          return state.workers.map((item, index) => {
                            return updateRelated({
                              id: item.id,
                              is_timer_start: false
                            })
                          })
                        })
                    ]

                    form.real_end_time = moment(form.real_end_time ? form.real_end_time :  moment()).utc().local().format()

                    vm.$db([
                        (vm.$q('SHIFT_CLOSE') as QueryBuilder)
                        .update(state.document.id, {
                          ...form
                        }),
                        vm.$q("UP_WAREHOUSE_INTERNAL")
                            .raw('warehouse.up_internal')
                            .action({
                                warehouse_id: warehouse_id,
                                shift_id: state.document.id,
                            }),
                        ...queries
                    ])
                    .then((result: ServerResult) => {
                      const operationResult = result.getOperation('SHIFT_CLOSE');
                      if (operationResult.hasError()) {
                        reject();
                      } else {
                        dispatch('loadData', { id: state.document.id, silence: true})
                        resolve(null)
                      }
                    }).catch((e: any) => {
                      console.log(e)
                      reject()
                    })
                }
            }).catch((e: any) => {
              console.log(e)
              reject()
            })
      })
    },

    toWork({ state, dispatch }) {
      const vm = (this as any)._vm;

      vm.$db([
          (vm.$q('SHIFT_TO_WORK') as QueryBuilder)
            .update(state.document.id, { status_id: state.inWorkStatus.id })
      ])
      .then(() => {
          dispatch('loadData', { id: state.document.id})
      })
    },
};

export const mutations: MutationTree<ShiftDetailsState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  SET_REMAINS_DATA(state, data) {
      state.remains = data.data
  },

  SET_SHIFT_DATA(state, {data, workers, notifications}) {
      const schema = data.schema;
      const document = data.documents[0];

      state.meta = fetchEnumsFromSchema(schema)
      state.meta_worker = fetchEnumsFromSchema(workers.schema)

      state.document = document
      console.log(workers)
      state.workers = workers.documents
      state.notifications = notifications.documents.filter((item: any) => {
          return item.done_time && moment(item.done_time).isAfter(moment().subtract(15, 'minute'))
      })
  },

  SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
      state.inWorkStatus = inWorkStatus;
      state.formationStatus = formationStatus;
  },
};

export const getters: GetterTree<ShiftDetailsState, RootState> = {
  canActionToWork: (state: ShiftDetailsState) => {
      return state.document.pipeline_code === 'active' && state.document.status_code === 'new';
  },
  canActionConfirmAction: (state: ShiftDetailsState) => {
      return (!!state.document.approve_by_id && state.document.approve_result === null);
  },
  disableActionConfirmActionCall: (state, getters, rootState) => {
      return !(state.document.approve_result === null && state.document.approve_by_id == (rootState as any).ubic.actor.document.id)
  },
  canActionToFormation: (state, getters, rootState) => {
      return !getters.canActionConfirmAction && (state.document.pipeline_code === 'active' && state.document.status_code === 'in_work');
  },
  hasActions: (state, getters, rootState) => {
      return getters.canActionToWork || getters.canActionConfirmAction || getters.canActionToFormation
  }
};

export const STORE_KEY = '$_shift_details';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
